const COOLDOWN_MS = 30 * 60 * 1000; // 30 minutes
const STORAGE_KEY = "surf_report_cooldowns";

interface CooldownMap {
  [spotKey: string]: number; // timestamp of last report per spot (camera)
}

function getCooldowns(): CooldownMap {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const map: CooldownMap = JSON.parse(raw);
    // Clean expired entries
    const now = Date.now();
    for (const key of Object.keys(map)) {
      if (now - map[key] > COOLDOWN_MS) delete map[key];
    }
    return map;
  } catch {
    return {};
  }
}

function saveCooldowns(map: CooldownMap) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
}

export function canReportForSpot(spotKey: string): boolean {
  const map = getCooldowns();
  const last = map[spotKey];
  if (!last) return true;
  return Date.now() - last > COOLDOWN_MS;
}

export function getRemainingCooldown(spotKey: string): number {
  const map = getCooldowns();
  const last = map[spotKey];
  if (!last) return 0;
  const remaining = COOLDOWN_MS - (Date.now() - last);
  return Math.max(0, remaining);
}

export function formatCooldown(ms: number): string {
  const minutes = Math.ceil(ms / 60000);
  return `${minutes} min`;
}

export function recordReport(spotKey: string) {
  const map = getCooldowns();
  map[spotKey] = Date.now();
  saveCooldowns(map);
}
